export default __webpack_public_path__ + "static/media/large-newyear2024.d030e833.jpg";